import { ScoreReading } from '@/components/ScoreReading'
import { useCountUp } from '@/ui/hooks/useCountUp'
import { isNil } from 'ramda'
import { View } from 'react-native'

/**
 * The score, on the one screen where it is the subject: no card under it, the figure straight on
 * the pink. It is the same reading Care's card wears, and the card there is what makes it a thing
 * to tap; here it is the page, so the surface comes away and only the number is left. It carries
 * no label of its own either: the heading above it already says whose score this is.
 */
const Panel = ({ score }: { score: number }) => {
	const { shown, progress } = useCountUp(score)

	return (
		<View>
			<ScoreReading shown={shown} progress={progress} tone="ground" />
		</View>
	)
}

const WallyHealthScore = ({ score }: { score?: number }) =>
	isNil(score) ? null : <Panel score={score} />

export { WallyHealthScore }
